<div class="auth-fluid">
  <!--Auth fluid left content -->
  <div class="auth-fluid-form-box">
    <div class="align-content-between d-flex h-100">
      <div class="card-body py-1">
        <!-- Logo -->
        <div class="auth-brand text-center">
          <a href="index.html">
            <span><img src="assets/img/icbeu2.png" alt="" height="72"/></span>
          </a>
          <h4 class="text-muted mt-2 lead font-weight-bold">INSTITUTO CULTURAL BRASIL - ESTADOS UNIDOS</h4>
        </div>
              
        <router-outlet></router-outlet>
      
        <!-- Footer-->
        <footer class="footer footer-alt d-none d-sm-block">
          <p class="">
            Version: 1.11.0 © 2019 - {{ currentYear }}. All Rights Reserved ICBEU Manaus. Plataforma online para alunos e professores.
          </p>
        </footer>
      </div>
      <!-- end .card-body -->
    </div>
    <!-- end .align-items-center.d-flex.h-100-->
  </div>
  <!-- end auth-fluid-form-box-->  

  <!-- Auth fluid right content -->
  <!--div class="auth-fluid-right text-center"> 
    
    <--div class="auth-user-testimonial">
      <h2 class="mb-3">I love the color!</h2>
      <p class="lead">
        <i class="mdi mdi-format-quote-open"></i> It's a elegent templete. I
        love it very much! . <i class="mdi mdi-format-quote-close"></i>
      </p>
      <p>
        - Hyper Admin User
      </p>
    </div -->
    <!-- end auth-user-testimonial--
  </div -->
  <!-- end Auth fluid right content -->
</div>
<particles [params]="paramsParticles" [style]="styleParticles"></particles>       